import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import Seo from "@/components/Seo";
import { SITE } from "@/config/site";

export default function NotFound() {
  return (
    <section className="flex min-h-[60vh] items-center justify-center px-4 py-24 text-center" data-testid="not-found-page">
      <Seo title={`Page Not Found — ${SITE.name}`} siteName={SITE.name} description="The page you are looking for does not exist." />
      <div>
        <p className="font-heading text-7xl font-extrabold text-navy-100 sm:text-8xl">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-navy-900 sm:text-3xl">Page not found</h1>
        <p className="mx-auto mt-3 max-w-md text-sm text-slate-600">
          The page you are looking for may have been moved or does not exist.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-navy-800 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-navy-700"
          data-testid="not-found-home-button"
        >
          <Home className="h-4 w-4" aria-hidden="true" /> Back to Home
        </Link>
      </div>
    </section>
  );
}
